import { Home } from 'lucide-react'
import StrutturaDisabilitaPage from './StrutturaDisabilitaPage'
import { CSS_LIST } from '../../data/struttureDisabilita'

export default function CssPageNew() {
  return (
    <StrutturaDisabilitaPage
      titolo="Comunità Socio Sanitarie"
      sottotitolo="CSS nel territorio della Provincia di Monza e Brianza"
      accentColor="#0ea5e9"
      accentColorB="#06b6d4"
      sezione="Comunità Socio Sanitarie"
      kpiLabel="Comunità Socio Sanitarie"
      icon={Home}
      tipo="CSS"
      lista={CSS_LIST}
      descrizione={
        <>

          <p style={{ fontSize: 13, color: 'var(--text-2)', lineHeight: 1.65, margin: '0 0 10px' }}>
            Le <strong style={{ color: 'var(--text-1)' }}>Comunità Socio Sanitarie (CSS)</strong> sono strutture
            residenziali a bassa intensità assistenziale destinate a persone con disabilità che hanno acquisito
            un sufficiente livello di autonomia personale.
          </p>

        </>
      }
    />
  )
}
